import { TFunction } from 'i18next';
import { useCallback } from 'react';
import { formattedDuration } from '../apps/dashboard/components/DurationFormat';

export const useDurationFormatter = (t: TFunction) =>
  useCallback(
    (timeInMinutes: number) => formattedDuration(t)(timeInMinutes),
    [t],
  );
